import { useMutation } from '@tanstack/react-query'
import { supabase } from '@/lib'

interface SubmitEnrollmentRequestParams {
  training_id: string
  full_name: string
  email: string
  country?: string
  city?: string
  whatsapp?: string
  last_diploma?: string
  professional_status?: string
}

export function useSubmitEnrollmentRequest() {
  return useMutation({
    mutationFn: async (params: SubmitEnrollmentRequestParams) => {
      const { data, error } = await supabase
        .from('enrollment_requests')
        .insert([
          {
            training_id: params.training_id,
            full_name: params.full_name,
            email: params.email,
            country: params.country || null,
            city: params.city || null,
            whatsapp: params.whatsapp || null,
            last_diploma: params.last_diploma || null,
            professional_status: params.professional_status || null,
            status: 'pending',
          },
        ])
      

      if (error) throw error
      return data
    },
  })
}
